export const LOCAL_STORAGE_KEYS = {
  helpHeader: "help-header",
  requestedFeatures: "requested-features",
  clearingOptimisationToggleHidden: "clearing-optimisation-toggle-hidden",
  customerSelectionInShellMenu: "customer-selection-in-shell-menu",
} as const;

export type LocalStorageItems = {
  [LOCAL_STORAGE_KEYS.helpHeader]: HelpHeader;
  [LOCAL_STORAGE_KEYS.requestedFeatures]: RequestedFeatures;
  [LOCAL_STORAGE_KEYS.clearingOptimisationToggleHidden]: boolean;
  [LOCAL_STORAGE_KEYS.customerSelectionInShellMenu]: boolean;
};

type LocalStorageKeys = keyof typeof LOCAL_STORAGE_KEYS;
export type LocalStorageValues = typeof LOCAL_STORAGE_KEYS[LocalStorageKeys];

type HelpHeader = {
  visitedPlaces?: string[];
};

type RequestedFeatures = {
  requestedFeatures?: string[];
};
